import { useTheme } from '@mui/material';

import { SVGPaletteProps } from './interfaces/svg-palette-props.interface';

export const StampCardIcon = (props: SVGPaletteProps) => {
  const theme = useTheme();
  const color = props.palette
    ? theme.palette[props.palette].dark
    : props.stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.675 4.5H6.375C5.27043 4.5 4.375 5.39543 4.375 6.5V17.5C4.375 18.6046 5.27043 19.5 6.375 19.5H17.375C18.4796 19.5 19.375 18.6046 19.375 17.5V12.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M15.675 4.5H6.375C5.27043 4.5 4.375 5.39543 4.375 6.5V17.5C4.375 18.6046 5.27043 19.5 6.375 19.5H17.375C18.4796 19.5 19.375 18.6046 19.375 17.5V12.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M15.675 4.5H6.375C5.27043 4.5 4.375 5.39543 4.375 6.5V17.5C4.375 18.6046 5.27043 19.5 6.375 19.5H17.375C18.4796 19.5 19.375 18.6046 19.375 17.5V12.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M15.675 4.5H6.375C5.27043 4.5 4.375 5.39543 4.375 6.5V17.5C4.375 18.6046 5.27043 19.5 6.375 19.5H17.375C18.4796 19.5 19.375 18.6046 19.375 17.5V12.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M8 10.5253L11.1679 13.6933C11.5584 14.0838 12.1916 14.0838 12.5821 13.6933L20.875 5.40039"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M8 10.5253L11.1679 13.6933C11.5584 14.0838 12.1916 14.0838 12.5821 13.6933L20.875 5.40039"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M8 10.5253L11.1679 13.6933C11.5584 14.0838 12.1916 14.0838 12.5821 13.6933L20.875 5.40039"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M8 10.5253L11.1679 13.6933C11.5584 14.0838 12.1916 14.0838 12.5821 13.6933L20.875 5.40039"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </svg>
  );
};
